module.exports = __webpack_public_path__ + "static/media/font-icon.5af92afa.png";